export class EngineViewState {
	ctid;

	get enabled() {
		return this.ctid !== undefined;
	}
}
